import * as React from 'react';
import { Product } from '@packages/common';
import { Translate } from '@packages/i18n';

import { FlagVariants, SimpleFlag } from './SimpleFlag';

interface SaleAndNewProductProps extends Pick<Product, 'price' | 'features' | 'createdAt'> {}

export const isOnSale = (price: Product['price'], sale?: boolean) =>
  sale && price.valueFormer && price.valueFormer > price.value;

export const SaleAndNewProductFlag: React.FC<SaleAndNewProductProps> = ({ price, features }) => {
  const sale = features ? features.sale : false;

  return isOnSale(price, sale) ? (
    <SimpleFlag variant={FlagVariants.sale}>{price.salePercentage}%</SimpleFlag>
  ) : features?.new ? (
    <SimpleFlag variant={FlagVariants.new}>
      <Translate translation="new" />
    </SimpleFlag>
  ) : null;
};

SaleAndNewProductFlag.displayName = 'SaleAndNewProductFlag';
